import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import $ from 'jquery';


@Component({
  selector: 'app-create-contact-company-form',
  templateUrl: './create-contact-company-form.component.html',
  styleUrls: ['./create-contact-company-form.component.css']
})
export class CreateContactCompanyFormComponent implements OnInit {
  // static modalOpen() {
  //   throw new Error('Method not implemented.');
  // }
  @Output()  emitEvent = new EventEmitter();
  constructor() { }

  ngOnInit() {}

  // openModal() {
  //   document.getElementById('add-client-modal-btn').click();
  // }
   modalOpen(){
    document.getElementById('add-client-modal-btn').click();
  }
   modalClosed() {
    this.emitEvent.emit({status: 'success'});
  }
  closeModal() {
    document.getElementById('add-client-close-modal').click();
  }
  eventEmitted({status}) {
    if(status === 'success') {
      this.closeModal();
      this.emitEvent.emit({status});
    }
  }

}
